import { render, staticRenderFns } from "./dependedStructure.vue?vue&type=template&id=40a48564&scoped=true&"
import script from "./dependedStructure.vue?vue&type=script&lang=js&"
export * from "./dependedStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a48564",
  null
  
)

export default component.exports